import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

export function ConfirmModal({intl, show, handleClose, onConfirm, message, title, cancelTextKey}) {
  return (
    <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{intl.formatMessage({ id: title ??  "confirmDialog.title" })}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{message ?? intl.formatMessage({ id: "confirmDialog.text" })}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            {intl.formatMessage({ id: cancelTextKey ??"confirmDialog.cancel" })}
          </Button>
          <Button variant="primary" onClick={onConfirm}>
            {intl.formatMessage({ id: "confirmDialog.confirmLabel" })}
          </Button>
        </Modal.Footer>
      </Modal>
  );
} 